// @flow

import {
  selectFeatureFlag,
  selectTaxesDisplaySetting,
} from '@gandi/authentication';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks';

import { RenewableProducts } from '../../shared/RenewableProducts/components/MainList';
import { DomainList as ListNDS } from '../componentsNDS/DomainList';
import { RenewCommercialBlock } from '../componentsNDS/RenewCommercialBlock';
import { SuggestedProducts } from '../componentsNDS/SuggestedProducts';
import { selectExtendedResults } from '../modules/selectors';

import ListLegacy from './DomainList';

export function NDSSwitch(): React.MixedElement | null {
  const FF_TRANSFERT_NDS = useAppSelector(state =>
    selectFeatureFlag(state, {
      featureFlagName: 'FF_TRANSFERT_NDS',
    }),
  );

  const results = useAppSelector(selectExtendedResults);
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);

  const translator = useTranslator();

  if (FF_TRANSFERT_NDS)
    return (
      <>
        <ListNDS />
        <SuggestedProducts />
        <RenewCommercialBlock />
      </>
    );

  return (
    <>
      {!!results.length && (
        <ListLegacy
          translator={translator}
          allResults={results}
          taxesIncluded={taxesIncluded}
        />
      )}
      <RenewableProducts translator={translator} />
    </>
  );
}
